import { ManagementSection } from './ManagementSection';
import { ComingSoonPlaceholder } from './ComingSoonPlaceholder';
import { ContentContainer } from '../../components/ContentContainer';
import { ChartIcon } from '../../components/ui/icons';

export const StatisticsSection = () => {
  const chartIcon = (
    <ChartIcon className="w-6 md:w-8 h-6 md:h-8 text-gray-400" />
  );

  return (
    <ManagementSection
      title="Statistics & Analytics"
      description="View detailed analytics about your venue's performance, visitor trends, and wine sales data."
      status="coming-soon"
    >
      <ContentContainer className="bg-gray-50 mt-4">
        <ComingSoonPlaceholder
          icon={chartIcon}
          title="Analytics Dashboard Coming Soon"
          description="Get insights into your venue's performance with comprehensive analytics including visitor metrics, wine sales trends, and customer engagement data."
          features="Features will include: Visitor analytics, sales reports, popular wines tracking, seasonal trends, and customer demographics."
        >
          {/* Placeholder chart mockups */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4 mt-4 md:mt-6">
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-3 md:p-4">
              <div className="h-24 md:h-32 bg-gradient-to-r from-primary-50 to-primary-100 rounded flex items-center justify-center">
                <span className="text-xs md:text-sm text-primary-800 font-medium text-center px-2">Visitor Trends Chart</span>
              </div>
            </div>
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-3 md:p-4">
              <div className="h-24 md:h-32 bg-gradient-to-r from-primary-50 to-primary-100 rounded flex items-center justify-center">
                <span className="text-xs md:text-sm text-primary-800 font-medium text-center px-2">Wine Sales Analytics</span>
              </div>
            </div>
          </div>
        </ComingSoonPlaceholder>
      </ContentContainer>
    </ManagementSection>
  );
};